import api from '../utils/api';
import config from '../config';

const lgspLogService = {
  // Get init data
  getInit: async () => {
    return api.get('/lgsp-logs/init');
  },

  // Get LGSP logs with pagination and filtering
  getLogs: async (params = {}) => {
    const cleanParams = {};
    Object.keys(params).forEach((key) => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        cleanParams[key] = params[key];
      }
    });
    return api.get('/lgsp-logs', cleanParams);
  },

  // Get LGSP log by ID
  getLogById: async (id) => {
    return api.get(`/lgsp-logs/${id}`);
  },

  // Verify citizen using device
  verifyCitizen: async (request) => {
    return api.post(`${config.endpoints.devices.list}/verify-citizen`, request);
  },

  // Get report data
  getReport: async (params = {}) => {
    const cleanParams = {};
    Object.keys(params).forEach((key) => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        cleanParams[key] = params[key];
      }
    });
    return api.get('/lgsp-logs/report', cleanParams);
  },

  // Export logs to Excel
  exportToExcel: async (params = {}) => {
    const cleanParams = {};
    Object.keys(params).forEach((key) => {
      if (params[key] !== null && params[key] !== undefined && params[key] !== '') {
        cleanParams[key] = params[key];
      }
    });
    return api.download('/lgsp-logs/export', 'LGSP_Logs.xlsx', cleanParams);
  },
};

export default lgspLogService;
